// @flow
import React, { memo } from 'react';
import Icon from 'react-icon-base';
import { type TIconBase } from './types.js.flow';

const IconLogotypeAuth = (props: TIconBase) => (
  <Icon width="160" height="90" viewBox="0 0 160 90" fill="none" {...props}>
    <path
      d="M148.39 69.8829C147.868 69.0738 147.146 68.4148 146.293 67.9706C145.44 67.5265 144.487 67.3126 143.527 67.3499H138.503L126.411 88.2138L117.152 78.6676L128.149 67.3499H118.116L107.119 78.6676L118.116 90H132.443L134.56 86.3836H149.5L151.617 90.0439H160L148.39 69.8829ZM137.452 81.3616L141.745 73.9532C141.786 73.8699 141.858 73.8062 141.946 73.776C142.033 73.7458 142.129 73.7516 142.212 73.7921C142.249 73.8068 142.281 73.8287 142.309 73.8563C142.337 73.884 142.358 73.9169 142.373 73.9532L146.652 81.3616H137.452ZM19.9343 67.3499H0V90H19.9343C22.4635 90 24.8891 88.9927 26.6775 87.1997C28.4659 85.4067 29.4706 82.9749 29.4706 80.4392V76.9107C29.4706 74.375 28.4659 71.9432 26.6775 70.1502C24.8891 68.3572 22.4635 67.3499 19.9343 67.3499ZM22.1833 81.7716C22.1852 82.085 22.1255 82.3957 22.0077 82.686C21.8898 82.9763 21.7161 83.2405 21.4964 83.4634C21.2767 83.6864 21.0154 83.8638 20.7273 83.9855C20.4392 84.1072 20.1301 84.1709 19.8175 84.1728H7.30194V73.2064H19.8321C20.4634 73.2064 21.0689 73.4579 21.5153 73.9054C21.9617 74.353 22.2125 74.96 22.2125 75.593L22.1833 81.7716ZM86.2358 67.3499L75.2245 78.6676L86.2358 90H96.2541L85.2574 78.6676L96.2541 67.3499H86.2358ZM53.494 67.3499H43.169C41.9143 67.3442 40.6707 67.5867 39.5096 68.0637C38.3485 68.5406 37.2927 69.2427 36.4027 70.1295C35.5127 71.0163 34.806 72.0705 34.3232 73.2316C33.8403 74.3928 33.5908 75.638 33.5889 76.8961V80.4246C33.5889 82.9603 34.5936 85.3921 36.382 87.1851C38.1704 88.9781 40.596 89.9854 43.1252 89.9854H53.5232C56.0524 89.9854 58.478 88.9781 60.2664 87.1851C62.0548 85.3921 63.0595 82.9603 63.0595 80.4246V76.9107C63.0595 74.3801 62.0588 71.9527 60.2767 70.1606C58.4946 68.3684 56.0765 67.3577 53.5524 67.3499H53.494ZM55.7576 81.7716C55.7595 82.085 55.6998 82.3957 55.582 82.686C55.4641 82.9763 55.2904 83.2405 55.0707 83.4634C54.851 83.6864 54.5897 83.8638 54.3016 83.9855C54.0135 84.1072 53.7044 84.1709 53.3918 84.1728H43.169C42.5377 84.1728 41.9322 83.9213 41.4858 83.4738C41.0394 83.0262 40.7886 82.4192 40.7886 81.7862V75.5637C40.7963 74.9384 41.0484 74.341 41.4909 73.9002C41.9333 73.4593 42.5307 73.2102 43.1544 73.2064H53.3771C54.0085 73.2064 54.6139 73.4579 55.0604 73.9054C55.5068 74.353 55.7576 74.96 55.7576 75.593V81.7716ZM98.7076 90H106.009V67.3499H98.7076V90ZM66.7835 90H74.0854V67.3499H66.7835V90Z"
      fill="#002B55"
    />
    <path
      d="M74.2023 40.3075C80.774 34.9386 85.6745 27.7951 88.3242 19.7218C90.5015 13.3915 91.2595 6.65761 90.544 0L111.428 12.0498C112.069 18.5946 111.297 25.2012 109.164 31.4202C106.492 39.592 101.51 46.8097 94.8229 52.1962L74.2023 40.3075Z"
      fill="url(#paint0_linear_4605_3714)"
    />
    <path
      d="M50.1644 25.9883C52.5719 18.4478 57.6259 12.0388 64.3885 7.95026L80.0439 16.9839C73.3184 21.0395 68.2939 27.4091 65.9073 34.9048C64.8842 37.9275 64.2702 41.0742 64.0818 44.2606L48.3389 35.1391C48.5457 32.0219 49.1594 28.9454 50.1644 25.9883Z"
      fill="url(#paint1_linear_4605_3714)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4605_3714"
        x1="92.9244"
        y1="39.6925"
        x2="92.9244"
        y2="10.5271"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0C6DEB" />
        <stop offset="0.49" stopColor="#069EB5" />
        <stop offset="1" stopColor="#00CD80" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4605_3714"
        x1="64.1841"
        y1="39.795"
        x2="64.1841"
        y2="6.28115"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0C6DEB" />
        <stop offset="0.49" stopColor="#069EB5" />
        <stop offset="1" stopColor="#00CD80" />
      </linearGradient>
    </defs>
  </Icon>
);

export default memo(IconLogotypeAuth);
